import { ref } from "vue";
import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

type LoginUrlRequest = {
  // Consumers pass the route-derived org id, which can be null before an org
  // is resolved; mirrors the previously-untyped Vuex action contract.
  organisationID: string | null;
};

export const useArcTitanStore = defineStore("arcTitan", () => {
  const link = ref<string | null>(null);

  const fetchArcTitanLoginUrl = async ({
    organisationID,
  }: LoginUrlRequest): Promise<void> => {
    const res = await $http.get<{ url: string }>(
      `${getApiClientUrl()}/v1/arctitan/${organisationID}/login/url`,
    );

    // The backend returns the fully-formed SSO login URL, token included.
    link.value = res.data.url;
  };

  return {
    link,
    fetchArcTitanLoginUrl,
  };
});
